import React from "react";
import bodyHelperTypes from "../../../utils/BodyHelperTypes";

const sP_Content = [

    {
        format: bodyHelperTypes.title,
        order: 10,
        content: "Hotlines and Other Resources"
    },

    {
        format: bodyHelperTypes.paragraphs,
        order: 20,
        content: [<><li>988 English/Spanish- text 988, chat online at <a href="https://988.ky.gov/">https://988.ky.gov/</a> or dial 988 then press 2 for Spanish speakers</li>
            <li>Veteran’s – text 988, chat online at <a href="https://988.ky.gov/">https://988.ky.gov/</a> or dial 988 then press 1 for Veterans</li>
            <li>Crisis Text Line- text KY to 741-741</li>
            <li>Trans Lifeline- (877) 565-8860</li>
            <li>Trevor Project- (212) 695-8650 or chat online at <a href="https://www.thetrevorproject.org/get-help/">https://www.thetrevorproject.org/get-help/ </a></li>
        </>]
    },
    {
        format: bodyHelperTypes.title,
        order: 30,
        content: "Prevention Resources"
    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 40,
        content: [<><a href="https://bit.ly/44bNJOu">https://bit.ly/44bNJOu</a>: At this link you can find various resources surrounding mental health promotion and suicide prevention, including but not limited to: Regional Prevention Resources, Social Media Toolkits, Disaster Anniversary Resources, Resources for Addressing and Preventing Suicide in Schools, and more. The resources at this link are continually updated and more are added when available.</>]
    },
    {
        format: bodyHelperTypes.title,
        order: 50,
        content: "Suicide Information and Resources"
    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 60,
        content: [<div className="no-bullet"><li><a className="quick-links-body" href="https://theactionalliance.org/our-strategy/national-strategy-suicide-prevention">National Strategy for Suicide Prevention</a></li>
            <li><a className="quick-links-body" href="https://www.hhs.gov/sites/default/files/sprc-call-to-action.pdf">Surgeon General’s Call to Action</a></li>
        </div>]
    },
    {
        format: bodyHelperTypes.title,
        order: 70,
        content: "State and Local Suicide Resources"
    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 80,
        content: [<div className="no-bullet" ><li><a className="quick-links-body" href="https://sprc.org/">Suicide Prevention Resource Center State Suicide Prevention</a></li>
        </div>]
    },
    {
        format: bodyHelperTypes.title,
        order: 90,
        content: "Survivors of Suicide Support Groups"
    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 100,
        content: [<div className="no-bullet"><li><a className="quick-links-body" href="https://sprc.org/state/kentucky/">Suicide Prevention Resource Center State Suicide Prevention</a></li>
        </div>]
    },

    {
        format: bodyHelperTypes.title,
        order: 110,
        content: "School Suicide Prevention Quick Guide"
    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 120,
        content: [
            <div>
                The <a href="https://drive.google.com/file/d/1vIda-DjZgy7qMo8ub3Uk5FhBAKOJJIlC/view?usp=drive_link">2025–2026 DBHDID School Suicide Prevention Quick Guide</a> provides an overview of best practices for implementing effective, evidence-based suicide prevention training in schools. It highlights the importance of aligning training with each school’s unique resources and care pathways, recommends programs for staff and students, and outlines practices to avoid. It also offers postvention support information and links to evidence-based resources through the Suicide Prevention Resource Center.
            </div>,
        ]
    },
    {
        format: bodyHelperTypes.title,
        order: 130,
        content: "DBHDID School Recommendations for Suicide Prevention Toolkit"
    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 140,
        content: [
            <div>
                The <a href="https://drive.google.com/file/d/1dPBJgqj1dwtwcZrpGMCq87YLpY-6TADF/view?usp=sharing">2025–2026 DBHDID School Recommendations for Suicide Prevention Toolkit</a> is a comprehensive resource designed to support Kentucky schools in developing robust, school-wide suicide prevention programs. It includes in-depth guidance on evidence-based training, trauma-informed language, prevention and intervention policies, and thoughtful use of AI-based risk monitoring. The toolkit promotes a coordinated, whole-school approach to supporting student mental health and well-being. 
            </div>,
        ]
    }

]


export default sP_Content;